import { fccColors } from './dataMaps';

const antennaSearchColors = {
  Towers: 'blue',
  Antennas: 'red',
};

const allColors = {
  FCCInfo: fccColors,
  'Antenna Search': antennaSearchColors,
};

const AntennaLegend = () => {
  return (
    <div className="mb-4 space-y-4">
      {Object.entries(allColors).map(([sectionName, colorMap]) => (
        <div key={sectionName} className="space-y-2">
          <h3 className="text-xs font-semibold capitalize">{sectionName}</h3>
          <div className="flex flex-wrap items-center gap-6">
            {Object.entries(colorMap).map(([label, color]) => (
              <div key={label} className="flex items-center gap-2">
                <div className="h-4 w-4 shrink-0 rounded-full" style={{ backgroundColor: color }} />
                <span className="text-xs text-gray-600">{label}</span>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default AntennaLegend;
